import { render, staticRenderFns } from "./menu-category-form.vue?vue&type=template&id=18741528"
import script from "./menu-category-form.vue?vue&type=script&lang=js"
export * from "./menu-category-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports